import throttle                  from "lodash.throttle";
import { useCallback, useState } from "react";

import { useGetHasVotedAtom, useSetHasVotedAtom } from "_common/hooks/polls";
import Toast                                      from "_common/toast";
import { updatePoll, voteOnPoll }                 from "_services/api/broadcast";

import Presentation from "./presentation";

const component = ( { isStudioPage, totalVotes, pollData, broadcastId, isPopOutChat, setPollsCount } ) => {

	const { id }                           = pollData;
	const [ deleteModal, showDeleteModal ] = useState ( false );
	const hasVoted                         = useGetHasVotedAtom ();
	const updateHasVoted                   = useSetHasVotedAtom ();

	const toggleDeleteModal = () => {
		showDeleteModal ( prev => !prev );
	};

	const handleEndDeletePoll = async ( deleteFlag, isActiveFlag ) => {
		if ( !id || !broadcastId ) return;

		const params = {
			sessionId : parseInt ( broadcastId ),
			pollId    : id,
			deleted   : deleteFlag,
			isActive  : isActiveFlag
		};

		try {
			await updatePoll ( params );

		} catch ( e ) {
			Toast.error ( e.displayMsg );
		}
	};

	const handleVote = useCallback ( throttle ( async optionId => {
		if ( !id || !broadcastId || !optionId ) return;

		const params = {
			sessionId : parseInt ( broadcastId ),
			pollId    : id,
			optionId
		};

		try {
			const data = await voteOnPoll ( params );

			if ( data?.status === "success" ) {
				setPollsCount ( count => count - 1 );

				updateHasVoted ( prev => ( {
					...prev,
					[id]: optionId
				} ) );

				Toast.success ( "Voted" );
			}

		} catch ( e ) {
			Toast.error ( e.displayMsg );
		}

	}, 1000, { trailing: false } ), [] );

	const calcMaxPercentage = options => {
		const max = options?.reduce ( ( prev, current ) => ( prev.votes > current.votes ) ? prev : current );

		return max;
	};

	return (
		<Presentation
			calcMaxPercentage       = { calcMaxPercentage }
			deleteModal             = { deleteModal }
			handleEndDeletePoll     = { handleEndDeletePoll }
			handleVote              = { handleVote }
			hasVotedValue           = { hasVoted }
			isPopOutChat            = { isPopOutChat }
			isStudioPage            = { isStudioPage }
			pollData                = { pollData }
			toggleDeleteModal       = { toggleDeleteModal }
			totalVotes              = { totalVotes }
		/>
	);
};

export default component;
